export default {
  SET_PAYSLIPS(state, payslips)
  {
    state.payslips = payslips
  },
  SET_PAYSLIPSENDER(state, payslipsender)
  {
    state.payslipsender = payslipsender
  }
}
